import { ProvidersFilterOptions } from "@app/projects/network-assessment/maps/network-coverage-map/enumerators";
import { MapExportSampleContentLayer } from "@app/projects/network-assessment/multi-map-export/utils/mapExportSampleSelection";
import { MultiMapExportMemberLayer } from "@app/projects/network-assessment/multi-map-export/interfaces";

export interface MapExportSamplePoint {
  readonly lat: number;
  readonly lng: number;
}

/**
 * Members with access cluster near the two network provider pins; members without access cluster far
 * from both. Only one Non-Terminated point sits past the county line — everything else, including
 * Terminated, stays inside.
 */
export const MAP_EXPORT_SAMPLE_POINTS: Record<MapExportSampleContentLayer, readonly MapExportSamplePoint[]> = {
  [MultiMapExportMemberLayer.WithAccess]: [
    { lat: 38.9745, lng: -94.8245 }, { lat: 38.9565, lng: -94.7975 }, { lat: 38.9445, lng: -94.8145 }, { lat: 38.9695, lng: -94.7895 },
    { lat: 38.831, lng: -94.9093 }, { lat: 38.809, lng: -94.8843 }, { lat: 38.814, lng: -94.9193 }, { lat: 38.837, lng: -94.8913 },
  ],
  [MultiMapExportMemberLayer.WithoutAccess]: [
    { lat: 38.8937, lng: -94.6583 }, { lat: 38.8687, lng: -94.6333 }, { lat: 38.8587, lng: -94.6513 }, { lat: 38.8917, lng: -94.6253 }, { lat: 38.9037, lng: -94.6453 },
    { lat: 38.85, lng: -94.615 }, { lat: 38.88, lng: -94.61 },
  ],
  [ProvidersFilterOptions.NonTerminated]: [{ lat: 38.9645, lng: -94.8095 }, { lat: 38.819, lng: -94.8993 }, { lat: 38.85, lng: -94.45 }],
  [ProvidersFilterOptions.Terminated]: [{ lat: 38.97, lng: -94.72 }],
  [ProvidersFilterOptions.AvailableProspect]: [{ lat: 38.839, lng: -94.9293 }, { lat: 38.794, lng: -94.8643 }],
  [ProvidersFilterOptions.TargetedProspect]: [{ lat: 38.9845, lng: -94.7695 }],
  [ProvidersFilterOptions.ExcludedProspect]: [{ lat: 38.8, lng: -95.02 }],
  [ProvidersFilterOptions.AvailableMarket]: [{ lat: 39.02, lng: -94.7 }, { lat: 38.75, lng: -94.95 }],
  [ProvidersFilterOptions.TargetedMarket]: [{ lat: 38.95, lng: -94.65 }],
  [ProvidersFilterOptions.ExcludedMarket]: [{ lat: 38.75, lng: -94.8 }],
};
